/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-reply': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M18.05 18.75a.625.625 0 01-.55-.313 9.494 9.494 0 00-8.125-4.687v3.75a.625.625 0 01-.387.575.625.625 0 01-.682-.131l-7.5-7.5a.625.625 0 010-.888l7.5-7.5a.625.625 0 01.682-.131.625.625 0 01.387.575v3.819a10.744 10.744 0 019.375 10.625c-.001.418-.029.835-.081 1.25a.625.625 0 01-.494.537l-.125.02zM9.062 12.5a11.013 11.013 0 018.438 3.75A9.569 9.569 0 008.694 7.5a.625.625 0 01-.569-.625V4.006L2.131 10l5.994 5.994v-2.869c0-.345.28-.625.625-.625h.338-.025z"/>'
  }
})
